import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tag-icon" }

import { useSlots, watchEffect } from 'vue';
import { Dot as IconDot } from '@/components/icons';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    type: {}
  },
  setup(__props: any) {

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/09/08 11:50:51
 * @description: tag
 */
const slots = useSlots();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['tag', __props.type])
  }, [
    _createElementVNode("span", _hoisted_1, [
      (_unref(slots).icon?.())
        ? _renderSlot(_ctx.$slots, "icon", { key: 0 })
        : (_openBlock(), _createBlock(_unref(IconDot), { key: 1 }))
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})